import { useEffect, useState } from "react";
import { Col, Container, Modal, Row, Button } from "react-bootstrap";
import { useLazyGetClientsByIdsQuery } from "../../libs/redux/slices/autocomxSlice/autocomxApiSlice";

import Loadingx from "../Loadingx/Loadingx";
import { normalizeClientIds, buildClientNameLines } from "./clientNames";
import ExcelJS from "exceljs";

const Metadatx = ({ opMetada, setOpMetada, metadaSelc, setMetadaSelc, metadaMaqSelc, metadaMaqExcel, setMetadaMaqExcel, describirMetadato, etiquetasPuerto }) => {
  const [findClients, { isLoading }] = useLazyGetClientsByIdsQuery();
  const [medadesc, setMetadesc] = useState(metadaSelc);
  const [finalMet, setFinalMet] = useState("");
  useEffect(() => {
    if (Object.keys(metadaMaqSelc).length > 0) {
      const loadMetadesc = async () => {
        const newMeta = { ...medadesc };
        const keys = Object.keys(metadaMaqSelc);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          switch (key) {
            case "CLIIDXXX": {
              //el metadato puede traer uno o varios clientes, se consultan todos de una vez
              const clientIds = normalizeClientIds(metadaMaqSelc["CLIIDXXX"]);
              if (clientIds.length === 0) break;

              let clients = [];
              try {
                const response = await findClients(clientIds);
                clients = response?.data?.data?.data ?? [];
              } catch (err) {
                console.error("Error buscando cliente:", err);
              }
              //el segundo useEffect se encarga de ubicarlo justo despues de CLIENTE
              newMeta["CLIENTE NOMBRE"] = buildClientNameLines(clientIds, clients);
              break;
            }
            case "USRCONTR":
              newMeta["CONTROLADOR"] = metadaMaqSelc["USRCONTR"];
              break;
            default:
              break;
          }
        }
        setMetadesc(newMeta);
      };
      loadMetadesc();
    }
    // eslint-disable-next-line
  }, []);


  //useeffect para organizar metadatos
  useEffect(() => {
    if (medadesc !== "") {
      let newObject = {};
      const keys = Object.keys(medadesc);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        newObject[key] = medadesc[key];
        if (key === "CLIENTE" && "CLIENTE NOMBRE" in medadesc) {
          newObject["CLIENTE NOMBRE"] = medadesc["CLIENTE NOMBRE"];
        }
      }
      //los metadatos de puertos guardan solo el codigo: se muestra codigo - nombre
      if (describirMetadato && etiquetasPuerto && metadaMaqSelc) {
        etiquetasPuerto.forEach((etiqueta, clave) => {
          if (!(etiqueta in newObject) || !(clave in metadaMaqSelc)) return;
          const descripcion = describirMetadato(clave, metadaMaqSelc[clave]);
          if (descripcion) newObject[etiqueta] = descripcion;
        });
      }
      setFinalMet(newObject);
    }
    // eslint-disable-next-line
  }, [medadesc, describirMetadato]);

  // Función para generar y descargar el Excel con ExcelJS
  const downloadExcel = async (docevalx, metdesxx) => {
    // Crear un nuevo libro de trabajo
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(metdesxx);
    docevalx.forEach((val, index) => {
      worksheet.addRow([val]);
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${metdesxx}.xlsx`;
    link.click();
  };

  return (
    <>
      <Modal size="lg" show={opMetada} onHide={() => {
        setOpMetada(false)
        setMetadaSelc("")
      }}>
        <Modal.Header style={{ "backgroundColor": "#000000", "color": "white" }}>
          METADATOS
          <Button className="btn-close btn-close-white" aria-label="Close"
            onClick={() => {
              setOpMetada(false)
              setMetadaSelc("")
            }} />
        </Modal.Header>
        <Modal.Body>
          {(isLoading) ? (
            <Loadingx
              width={50}
              height={50}
            />
          ) : (
            <Container>
              {
                Object.keys(finalMet).map(item => {
                  let typeMet = "";
                  if (typeof finalMet[item] === "object" && finalMet[item] !== null) {
                    if (item === "CONTROLADOR" && finalMet[item]?.label) {
                      typeMet = finalMet[item].label;
                    } else if (Array.isArray(finalMet[item])) {
                      //los nombres de cliente van uno por linea para que se lean junto a su nit
                      typeMet = item === "CLIENTE NOMBRE"
                        ? finalMet[item].map((line, index) => <div key={`cli_${index}`}>{line}</div>)
                        : finalMet[item].join(", ");
                    }
                  } else {
                    typeMet = finalMet[item];
                  }

                  return (
                    <Row key={`itm_${item}`}>
                      <Col className="border-bottom border-dark d-grid justify-content-center">
                        {item}:
                      </Col>
                      <Col className="border-bottom border-dark d-grid justify-content-center">
                        {typeMet}
                      </Col>
                    </Row>
                  )
                })
              }
              {/* metadatos excel */}
              {metadaMaqExcel && metadaMaqExcel.length > 0 && metadaMaqExcel.map((item, index) => {
                return (
                  <Row key={`excel_row_${index}`}>
                    <Col className="border-bottom border-dark d-grid justify-content-center">
                      {item.METDESXX}:
                    </Col>
                    <Col className="border-bottom border-dark d-grid justify-content-center">
                      <button
                        onClick={() => downloadExcel(item.DOCEVALX, item.METDESXX)}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: 'blue',
                          textDecoration: 'underline',
                          cursor: 'pointer',
                        }}
                      >
                        Link de descarga
                      </button>
                    </Col>
                  </Row>
                );
              })}
            </Container>
          )
          }
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Metadatx;
